import { render, staticRenderFns } from "./zh_ordos_ticket.vue?vue&type=template&id=084dce57&"
import script from "./zh_ordos_ticket.vue?vue&type=script&lang=js&"
export * from "./zh_ordos_ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports